import styled from 'styled-components';
import List from '@material-ui/core/List';
export const StyledListBody = styled(List)`
  width: 100%;
  max-width: 360px;
  background-color: #ffffff;
  .MuiCheckbox-colorPrimary.Mui-checked {
    color: #005099 !important;
  }
`;
export const StyledBody = styled.div`
  width: 300px;
  margin: 16px;
`;
export const StyledBodyText = styled.div`
  span {
    font-size: 14px;
    font-family: 'OpenSans-Regular';
    color: #525252;
    line-height: 18px;
  }
`;